// TODO(#695 follow-up): replace these placeholder sections with clinically
// reviewed copy before launch. Sections are intentionally marked
// "(Placeholder)" so manual QA surfaces unreviewed content.

export interface ProtocolSection {
  id: string
  title: string
  body: string
}

export const PROTOCOL_PLACEHOLDER_NOTE =
  'The content below is placeholder copy. Final protocol language will be clinically reviewed prior to launch.'

export const PROTOCOL_SECTIONS: ProtocolSection[] = [
  {
    id: 'acne-scope',
    title: 'Acne treatment scope (Placeholder)',
    body: `Determa's initial clinical scope is limited to adult and adolescent acne vulgaris, including comedonal, inflammatory, and mild-to-moderate nodulocystic presentations.

Conditions outside this scope — rosacea, hidradenitis suppurativa, pigmentary disorders, skin cancer screening, and pediatric patients under 12 — should be referred to in-person care or deferred until additional specialty scopes are enabled on the platform.

When a visit surfaces a finding outside scope, document the referral clearly in the plan and advise the patient accordingly.`,
  },
  {
    id: 'ai-workflow',
    title: 'AI documentation workflow (Placeholder)',
    body: `Determa's AI assists with clinical documentation by generating a structured note from the visit transcript. The provider remains the author of record and is responsible for reviewing, editing, and signing each note before it is finalized.

AI-generated content is a draft. Do not sign a note that contains uncorrected hallucinations, incorrect dosing, or missing assessment/plan elements. Use the edit controls to correct any inaccuracies prior to signing.

Transcripts and generated notes are retained per the platform's data retention policy and are handled in accordance with HIPAA requirements.`,
  },
  {
    id: 'platform-conventions',
    title: 'Platform conventions (Placeholder)',
    body: `Video visits occur through the patient-facing booking page. Patients select a visit type, confirm a time, and complete payment before the visit. At the scheduled time, both parties join the video room from within the Determa app.

Communication with patients outside of visits is limited to the platform's messaging tools to maintain an auditable record and prevent PHI exposure on personal channels.

Prescriptions are sent through the integrated e-prescribing system. Controlled substances follow the state-specific rules for telehealth prescribing and may require additional documentation.`,
  },
]
